import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { buildCurrentLocationPath, buildRouteWithContinueUrl } from '../utils/authContinueUrl';

const EntitlementBasedRoute = ({ children, requireAdmin, requiredEntitlements }) => {
  const { currentUser, userStatus, userRoles, userEntitlements } = useAuth();
  const location = useLocation();
  const continuePath = buildCurrentLocationPath(location);

  if (!currentUser) {
    return <Navigate to="/" />;
  }

  // STRICT: Check Firebase Auth emailVerified as source of truth
  // Policy change: ADR-077 supersedes ADR-015 (verify-later pattern)
  if (!currentUser.emailVerified) {
    return <Navigate to={buildRouteWithContinueUrl('/verify-email', continuePath)} />;
  }

  // Secondary check: Firestore status (handles edge cases during sync)
  if (userStatus === 'pending_verification') {
    return <Navigate to={buildRouteWithContinueUrl('/verify-email', continuePath)} />;
  }

  // Admin check
  if (requireAdmin && !userRoles.includes('admin')) {
    return <Navigate to="/unauthorized" />;
  }

  // Entitlement check
  if (requiredEntitlements && requiredEntitlements.length > 0) {
    const hasRequired = requiredEntitlements.some(ent => userEntitlements.includes(ent));
    if (!hasRequired) {
      return <Navigate to="/unauthorized" />;
    }
  }

  return children;
};

export default EntitlementBasedRoute;
